import React, { useState } from "react";
import {
  Autocomplete,
  TextField,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  Paper,
  Button,
  Typography,
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { styled } from "@mui/material/styles";

// const options = [
//   { label: "Option 1", id: 1 },
//   { label: "Option 2", id: 2 },
//   { label: "Option 3", id: 3 },
//   { label: "Option 4", id: 4 },
// ];

// Custom Paper component for dropdown with sticky footer
const CustomPaper = ({ children, onDone, onClear }) => (
  <Paper>
    {children}
    <div style={{ 
      position: "sticky", 
      bottom: 0, 
      background: "#fff", 
      padding: "8px", 
      borderTop: "1px solid #ccc", 
      display: "flex", 
      justifyContent: "space-between" 
    }}>
      <Button size="small" color="error" onClick={onClear}>
        Clear All
      </Button>
      <Button variant="contained" size="small" onClick={onDone}>
        Done
      </Button>
    </div>
  </Paper>
);

export default function FieldsAutoComplete({ options, selectedFields, setSelectedFields }) {
  //const [selectedValues, setSelectedValues] = useState([]);
  const [open, setOpen] = useState(false);

  return (
    <div>
      {/* Autocomplete Dropdown */}
      <Autocomplete
        multiple
        options={options}
        disableCloseOnSelect
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        getOptionLabel={(option) => option.displayName}
        value={options.filter(opt => selectedFields.some(sel => sel.fieldName === opt.fieldName))}
        onChange={(event, newValue) => {
          setSelectedFields(newValue);
        }}
        renderTags={() => null} // Hide selected items in input field
        PaperComponent={(props) => (
          <CustomPaper 
            {...props} 
            onDone={() => setOpen(false)} 
            onClear={() => {
              setSelectedFields([]);
            }} 
          />
        )}
        renderOption={(props, option, { selected }) => {
            const { key, ...restProps } = props; // Extract key to avoid spreading it
            return (
              <li {...restProps} key={option.fieldName}> {/* Use fieldName as key */}
                <Checkbox
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                <Typography variant="body2">{option.displayName}</Typography>
              </li>
            );
          }}
          
        renderInput={(params) => (
          <TextField {...params} label="Select Options" size="small" />
        )}
      />

      
    </div>
  );
}
